import React, { useState } from 'react';
import PatientControlButton from 'components/atoms/patentControlButton';
import { useTranslation } from 'react-i18next';
import CallControlIcon from 'components/atoms/icons/callControlIcon';
import FalseMonthlyInteractionIcon from 'components/atoms/icons/falseMontlyInteractionIcon';
import { useAppSelector } from 'store';
import CcmInteractionStatusModal from 'components/molecules/ccmInteractionStatus/modal';
import { useAccess } from 'infrastructure/hooks/access/useAccess';

import type { ModuleType } from 'infrastructure/enums';

interface IProps {
  module: ModuleType;
  patientGuid: string;
}

const FollowUpAppointmentCompleteControl: React.FC<IProps> = (props) => {
  const { module, patientGuid } = props;
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const {
    patientInfo,
    isCombinedModule,
    isReadOnlyRole,
    isBlockCcmModule,
    isCcmActionDisabled,
  } = useAccess({
    module,
    patientGuid,
  });

  const { togglePatientCcmInteractionStatus: updateCcmInteractionLoading } =
    useAppSelector((state) => state.loading.effects.adminPanelPatients);

  const ccmInteractionStatus = patientInfo?.ccmInteractionStatus;
  const icon = ccmInteractionStatus
    ? CallControlIcon
    : FalseMonthlyInteractionIcon;
  const status = ccmInteractionStatus
    ? t('controls.true')
    : t('controls.false');
  const disabled =
    (isCombinedModule && (isReadOnlyRole || isBlockCcmModule)) ||
    ccmInteractionStatus ||
    isCcmActionDisabled;

  return (
    <>
      <PatientControlButton
        label={t('labels.followUpAppointmentCompleteCcm')}
        Icon={icon}
        status={status}
        loading={updateCcmInteractionLoading}
        disabled={disabled}
        handleClick={() => setOpen(true)}
        extraAccent={!ccmInteractionStatus}
      />
      <CcmInteractionStatusModal
        isOpen={open}
        toggle={setOpen}
        patientGuid={patientGuid}
      />
    </>
  );
};

export default FollowUpAppointmentCompleteControl;
